import React, { useEffect, useState } from "react";

import Image from "../../components/image";
import ArrowRightIcon from "../../images/icons/arrow-right-icon.inline.svg";
import HeartIcon from "../../images/icons/fi-rr-heart.inline.svg";
import ShareIcon from "../../images/icons/share-icon.inline.svg";
import { Link } from "../../utils/customLink";
import { shareIcons } from "../../utils/shareIcons";

/**
 * type:
 * focus - Card used for program focus page
 * text - Card used for text page
 * program - Card used for 404 page
 */
const ArticleCard = ({
  article,
  type,
  wholeSelectable,
  extraContentClass = ""
}) => {
  const [openShareWith, setOpenShareWith] = useState(false);
  const [shareUrl, setShareUrl] = useState("");
  const shareWithMediaArr = shareIcons(shareUrl);

  useEffect(() => {
    setShareUrl(encodeURI(article?.uri ?? "#"));
  }, [article?.uri]);

  if (!article) return <></>;

  return (
    <>
      <div className="relative">
        {article && (
          <Image
            image={article?.img}
            imageAlt={article?.title}
            imageClass={
              "object-cover object-center w-full h-[140px] rounded-t-md"
            }
            sourceUrl={article?.sourceUrl}
          />
        )}
        <div
          className={`absolute flex gap-3 top-5 left-5 z-10 ${
            type === "focus" ? "hidden" : ""
          }`}
        >
          {type === "text" && (
            <HeartIcon className="fill-white hover:opacity-80 hidden" />
          )}
          <div className="relative flex items-center cursor-pointer justify-right">
            {!openShareWith && type !== "focus" && (
              <ShareIcon
                onClick={() => setOpenShareWith(!openShareWith)}
                className="fill-white hover:opacity-80"
              />
            )}
            {openShareWith && (
              <div className="absolute -top-[14px] -left-[32px]">
                <ul
                  className="flex flex-col gap-2 border border-gray-lighter rounded-xxxxl p-3 planet:bg-gray-dark"
                  style={{
                    boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.25)"
                  }}
                >
                  <li>
                    <ShareIcon
                      fill={"#FFFFFF"}
                      onClick={() => setOpenShareWith(!openShareWith)}
                      className={"hover:opacity-80 w-5 h-5"}
                    />
                  </li>
                  {shareWithMediaArr &&
                    shareWithMediaArr.length > 0 &&
                    shareWithMediaArr.map((media, idx) => {
                      return <li key={idx}>{media.node}</li>;
                    })}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={`h-auto p-4 pt-0 text-center rounded-b text-gray-generic ${
          type === "program"
            ? "bg-yellow-lighter planet:bg-gray-dark"
            : "bg-white planet:gvi-dark-gray-bg"
        } ${extraContentClass}`}
      >
        <div className="flex justify-between items-center h-[97px] py-2 width-divider !border-gray-generic">
          <div
            className="h3 planet:!font-light text-left"
            dangerouslySetInnerHTML={{
              __html:
                article?.title?.length > 48
                  ? `${article?.title?.substring(0, 48)}...`
                  : article?.title
            }}
          />
          {type === "program" && (
            <Link to={article?.uri}>
              <ArrowRightIcon className="stroke-black-lighter planet:stroke-white" />
            </Link>
          )}
        </div>

        {type === "focus" && (
          <div className="flex flex-row items-center h-[87px] justify-between py-2">
            <div>
              <div
                className="uppercase text-[0.875rem] leading-[1.225rem] font-medium text-generic-text planet:text-gray-darken text-left"
                dangerouslySetInnerHTML={{ __html: article?.author }}
              />
              <p className="text-[0.75rem] leading-[155.5%] text-left text-generic-text planet:text-gray-generic">{`Posted: ${article?.postedDate}`}</p>
            </div>
            <div>
              <ArrowRightIcon className="ml-4 stroke-black-lighter planet:stroke-white" />
            </div>
          </div>
        )}
        {article?.desc && (
          <div className="pt-5  text-left text-black-lighter planet:text-gray-generic">
            <div
              className="pb-4"
              dangerouslySetInnerHTML={{ __html: article?.desc }}
            />
            {type === "text" && article?.duration && (
              <p className="font-bold planet:font-normal planet:text-white">
                {article?.duration}
              </p>
            )}
            {type === "text" && article?.uri && (
              <>
                <Link to={article?.uri} className="relative z-10">
                  <p className="inline-block underline hover:font-bold planet:hover:font-normal planet:hover:text-white">
                    {article?.ctaTitle ?? "Read more"}
                  </p>
                </Link>
                {wholeSelectable === true && (
                  <Link
                    to={article?.uri}
                    className="absolute z-0 top-0 left-0 right-0 bottom-0"
                  />
                )}
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default ArticleCard;

ArticleCard.defaultProps = {
  type: "focus"
};
